<template>
  <div class="personal-data-component">
    <div class="personal-data">
      <ProfileNavbar></ProfileNavbar>
      <div class="data-wrap">
        <div class="base-info-wrap">
          <div class="address-info-wrap">
            <div class="address-count-tip">共{{ list.length }}个地址，最多保存10个</div>
            <el-table :data="list" v-loading="loading" element-loading-text="给我一点时间"
              :empty-text="emptyText" border fit highlight-current-row>
              <el-table-column label="收件人姓名" align="center" width="150" prop="recipient_name">
              </el-table-column>
              <el-table-column label="收件人姓名" align="center" width="150" prop="recipient_phone">
              </el-table-column>
              <el-table-column label="地址" align="center" minWidth="180">
                <template slot-scope="scope">
                  <p>{{ scope.row.province }}{{ scope.row.city }}{{ scope.row.district }}{{ scope.row.detail }}</p>
                </template>
              </el-table-column>
              <el-table-column label="是否默认" align="center" minWidth="80">
                <template slot-scope="{row}">
                  <p>{{ row.is_default ? '是' : '否' }}</p>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="200" fixed="right">
                <template slot-scope="scope">
                  <el-button type="text" @click="handleShowEditAddress(scope.row)">编辑</el-button>
                  <el-button type="text" @click="handleDeleteAddress(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>

            <div class="add-address-wrap" @click="handleShowAddAddress">
              <div class="add-icon">+</div>
              <p>新增地址（最多添加10个）</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 新建地址 -->
    <add-address :visible.sync="showAddForm" @getList="getList" />
    <!-- 编辑地址 -->
    <edit-address :oldAddress="oldAddress" :visible.sync="showEditForm" @getList="getList" />
  </div>
</template>

<script>
import { getAddressList, deleteAddress } from "@/api/address";
import ProfileNavbar from "@/components/profileNavbar"
import AddAddress from "./components/addAddress"
import EditAddress from "./components/editAddress"
export default {
  name: 'UserAddress',
  components: {
    ProfileNavbar,
    AddAddress,
    EditAddress,
  },
  data() {
    return {
      loading: false,
      showAddForm: false,
      showEditForm: false,
      list: [],
      oldAddress: {},
      emptyText: '暂无数据',
      total: 0,
      listQuery: {
        page: 1,
        pagesize: 10
      },
    };
  },
  computed: {

  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      getAddressList({}).then(res => {
        this.list = res.data.list;
        this.total = res.data.count * 1;
        this.loading = false;
      }).catch((err) => {

      });
    },
    // 删除项目
    handleDeleteAddress(address) {
      this.$confirm('确定要删除此地址吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.loading = true;
        deleteAddress({
          id: address.id
        })
          .then((response) => {
            this.loading = false;
            this.getList();
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    handleShowAddAddress() {
      this.showAddForm = true;
    },
    handleShowEditAddress(address) {
      this.oldAddress = address
      this.showEditForm = true;
    },
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/profile.less';
</style>
